module.exports = __webpack_public_path__ + "img/quadro.95a1d194.png";